import type { LazyStyleModuleImport } from "../../common/runtime/utils/useShadowStylesInjector.ts";

/**
 *
 *
 *
 */
export const iconRegistryStyles: LazyStyleModuleImport = () => import("./icon.g.scss?inline");
